import { getAttr, getEntityId } from '../../../../features/helpers/apiHelpers';

export const mapFieldTemplate = (fieldTemplate) => {
  return {
    title: getAttr(fieldTemplate, 'name'),
    content: getAttr(fieldTemplate, 'text'),
    key: getEntityId(fieldTemplate),
    fieldType: getAttr(fieldTemplate, 'fieldType'),
  };
};
